import { render, staticRenderFns } from "./WelcomeHeader.vue?vue&type=template&id=4273aad9&scoped=true&"
import script from "./WelcomeHeader.vue?vue&type=script&lang=js&"
export * from "./WelcomeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4273aad9",
  null
  
)

export default component.exports